export default from './restriction-private-member';



// WEBPACK FOOTER //
// ./app/components/restriction-private-member/index.js